import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiStore {
  sidebarCollapsed: boolean;
  activeModule: string;
  searchOpen: boolean;

  // Actions
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setActiveModule: (module: string) => void;
  setSearchOpen: (open: boolean) => void;
}

export const useUiStore = create<UiStore>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      activeModule: 'dashboard',
      searchOpen: false,

      toggleSidebar: () =>
        set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),

      setSidebarCollapsed: (collapsed) =>
        set({ sidebarCollapsed: collapsed }),

      setActiveModule: (module) => set({ activeModule: module }),

      setSearchOpen: (open) => set({ searchOpen: open }),
    }),
    {
      name: 'veriaxis-ui',
      partialize: (state) => ({ sidebarCollapsed: state.sidebarCollapsed }),
    },
  ),
);
